// src/components/About.js
import React from "react";
import { about, team } from "../data/about";

export default function About() {
  return (
    <div className="px-6 lg:px-40 md:px-12 py-10 flex justify-center @container">
      <div className="w-full max-w-[960px] space-y-10">

        {/* Page Header */}
        <header className="mb-4">
            <h1 className="text-2xl md:text-3xl font-bold tracking-tight text-[#0e1b17]">
              About Us
            </h1>
      </header>

        {/* Mission / Vision */}
        <section className="grid md:grid-cols-2 gap-4">
          <div className="card p-6">
            <h3 className="heading-2">Our Mission</h3>
            <p className="muted mt-2">{about.mission}</p>
          </div>
          <div className="card p-6">
            <h3 className="heading-2">Our Vision</h3>
            <p className="muted mt-2">{about.vision}</p>
          </div>
          <div className="card p-6">
            <h3 className="heading-2 mb-2">Challenges</h3>
            <ul className="list-disc list-inside space-y-1 text-[15px] text-[#4e977f]">
              {about.challenges.map((c, i) => (
                <li key={i}>
                <span className="font-bold"> {c.title} </span>
                <div> {c.text} </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="card p-6">
            <h3 className="heading-2 mb-2">Help Us</h3>
            <ul className="list-disc list-inside space-y-1 text-[15px] text-[#4e977f]">
              {about.helpus.map((c, i) => (
                <li key={i}>
                <span className="font-bold"> {c.title} </span>
                <div> {c.text} </div>
                </li>
              ))}
            </ul>
          </div>
        </section>

        {/* Impact Stats (circles) */}
        <section className="py-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {about.stats.map((s) => (
              <div key={s.label} className="flex flex-col items-center text-center gap-2">
                <div className="flex items-center justify-center w-24 h-24 md:w-28 md:h-28 rounded-full bg-[#e7f3ef] shadow">
                  <span className="text-xl md:text-2xl font-bold text-[#0e1b17]">
                    {s.value}
                  </span>
                </div>
                <p className="text-sm md:text-base text-[#4e977f] font-medium">{s.label}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Geography */}
        {about.geography && (
          <section className="card p-6">
            <h3 className="heading-2 mb-1">Where We Work</h3>
            <p className="muted mb-2">
              Our residential school is based in Karmala, Solapur District, Maharashtra. Children also come from nearby blocks and districts:
            </p>
            <ul className="list-disc list-inside space-y-1 text-[15px] text-[#2a3a36]/85">
              <li>Karmala (Solapur)</li>
              <li>Madha (Solapur)</li>
              <li>Karjat (Ahilyanagar)</li>
              <li>Jamkhed (Ahilyanagar)</li>
              <li>Indapur (Pune)</li>
            </ul>
          </section>
        )}

        {/* Legal Status */}
        {about.legal?.length > 0 && (
          <section className="">
            <h3 className="heading-2 mb-3">Legal & Compliance</h3>
            <div className="card p-0 overflow-hidden">
              <div className="overflow-x-auto">
                <table className="min-w-full text-sm">
                  <thead className="bg-[#f8fcfa] text-[#4e977f]/80">
                    <tr>
                      <th className="px-4 py-3 text-left">Certificates</th>
                      <th className="px-4 py-3 text-left">Registration No.</th>
                      <th className="px-4 py-3 text-left">Date</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-[#e7f3ef]">
                    {about.legal.map((row, i) => (
                      <tr key={i} className="hover:bg-[#f9fefb]">
                        <td className="px-4 py-3">{row.act}</td>
                        <td className="px-4 py-3 font-medium text-[#0e1b17]">{row.reg}</td>
                        <td className="px-4 py-3">{row.date}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        )}

        {/* CTA */}
        <section className="card p-8 text-center">
          <h3 className="heading-2">Join Our Mission</h3>
          <p className="muted mt-2">
            Volunteer, Donate, or Collaborate to expand our programs and reach more children.
          </p>
          <a href="/contact" className="btn-primary mt-4 inline-flex">
            Get Involved
          </a>
        </section>
      </div>
    </div>
  );
}
